import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './redux/storeConfig/store'
import { ThemeContext } from './context/ThemeColor'
import { IntlProviderWrapper } from './context/Internationalization'
import Spinner from './core/components/spinner/Fallback-spinner'
import * as serviceWorker from './serviceWorker'
import LoadingContextProvider, { Loading } from 'src/context/Loading'
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'src/core/scss/react/libs/toastify/toastify.scss'
import 'src/core/scss/react/apps/app-users.scss'
import 'src/core/scss/react/libs/tables/react-dataTable-component.scss'
import 'src/core/scss/react/libs/react-select/_react-select.scss'
import 'src/core/scss/react/libs/flatpickr/flatpickr.scss'
import './core/components/ripple-button'
import './core/assets/fonts/feather/iconfont.css'
import './core/scss/core.scss'
import './assets/scss/style.scss'
import 'primereact/resources/themes/lara-dark-purple/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import { Web3ReactProvider } from '@web3-react/core'
import getLibrary from './utils/getlibrary'
import { PrimeReactProvider, PrimeReactContext, FilterMatchMode } from 'primereact/api'

const value = {
	filterMatchMode: {
		text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
		numeric: [
			FilterMatchMode.EQUALS,
			FilterMatchMode.NOT_EQUALS,
			FilterMatchMode.LESS_THAN,
			FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
			FilterMatchMode.GREATER_THAN,
			FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
		],
		date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER],
	},
}

const LazyApp = lazy(() => import('./App'))
ReactDOM.render(
	<Web3ReactProvider getLibrary={getLibrary}>
		<Provider store={store}>
			<PersistGate persistor={persistor} loading={null}>
				<Suspense fallback={<Spinner />}>
					<LoadingContextProvider>
						<ThemeContext>
							<IntlProviderWrapper>
								<PrimeReactProvider value={value}>
									<LazyApp />
								</PrimeReactProvider>
								<ToastContainer newestOnTop />
							</IntlProviderWrapper>
						</ThemeContext>
						<Loading />
					</LoadingContextProvider>
				</Suspense>
			</PersistGate>
		</Provider>
	</Web3ReactProvider>,
	document.getElementById('root'),
)
serviceWorker.unregister()
